import { styled, css, Box } from '@mui/material'
import Text from '../../Text'

export const SummaryGroupItemContainer = styled(Box)(
  ({ theme }) => css`
    display: flex;
    border-bottom: 1px solid ${theme.palette.grey[400]};
    gap: 8px;
    padding: 12px 0;
  `
)

export const SummaryGroupWrapper = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    :not(:first-child) {
      padding: 20px 0 0 0;
    }
  `
)

export const SummaryGroupHeader = styled(Box)(
  () => css`
    display: flex;
    align-items: center;
    gap: 20px;
    padding-top: 12px;
  `
)

export const GroupProductsSubtitle = styled(Text)(
  ({ theme }) => css`
    font-size: 10px;
    font-weight: 400;
    color: ${theme.palette.text.secondary};
  `
)
